import React from 'react'
import { GlobalDataContext, useCategoryStore } from '../../common'

export const useCategoryUiStore = () => {
  const context = React.useContext(GlobalDataContext)

  if (!context) {
    throw new Error('useCategoryUiStore() must be used within the GlobalDataContext')
  }

  return useCategoryStore().uiStore
}
